import { Alert } from "@jugl-web/ui-components/cross-platform/Alert/Alert";
import { useTranslations } from "@jugl-web/utils";
import { useFeaturesShowcaseModal } from "@web-src/modules/entities/components/FeaturesShowcaseModal/useFeaturesShowcaseModal";
import image from "./assets/title.gif";

export const InvitationAlert = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslations();
  const { isOpen: isFeaturesShowcaseModalOpen } = useFeaturesShowcaseModal();
  return (
    <Alert
      className="h-[323px] w-[448px]"
      img={
        <img
          src={image}
          alt="Invitation Alert"
          className="h-[104px] w-[104px]"
        />
      }
      isOpen={!isFeaturesShowcaseModalOpen && isOpen}
      title={t({
        id: "entity-invitation-alert.title",
        defaultMessage: "You've Been Invited to a New Workspace",
      })}
      contentContainerClassName="px-6 pb-5 pt-6"
      titleAndContentContainerClassName="gap-2"
      imgContainerClassName="mb-0"
      titleClassName="text-lg text-dark font-medium"
      content={
        <div className="text-base tracking-normal text-[#707577]">
          {t({
            id: "entity-invitation-alert.content",
            defaultMessage:
              "You’ve received an invitation to join a workspace. You can view the invite and join when you're ready.",
          })}
        </div>
      }
      buttonsContainerClassName="mt-6 w-full grid grid-cols-[163px_auto] gap-4"
      buttons={[
        {
          text: t({ id: "common.cancel", defaultMessage: "Cancel" }),
          role: "close",
          className:
            "font-normal font-secondary text-dark-700 w-[120px] justify-self-end h-10",
        },
        {
          text: t({
            id: "entity-invitation.view-invite",
            defaultMessage: "View Invite",
          }),
          className:
            "font-normal font-secondary w-[181px] justify-self-start h-10",
          color: "primary",
          onClick: (_, actions) => {
            onClose();
            actions.closeAlert();
            document
              .querySelector<HTMLButtonElement>(
                "[data-id=select-entity-popover-trigger]"
              )
              ?.click();
          },
        },
      ]}
      onRequestClose={onClose}
    />
  );
};
